import { h } from 'preact';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import styles from './global.css';

export default function makeTable(columns) {
  function renderColumn(column) {
    const [title, width] = column;
    return <TableCell style={{ width: `${width}%` }}>{title}</TableCell>;
  }

  const renderedColumns = columns.map(renderColumn);

  function DynamicTable(props) {
    const { children } = props;
    return (
      <TableContainer>
        <Table stickyHeader aria-label="sticky table" className={styles.table}>
          <TableHead>
            <TableRow>{renderedColumns}</TableRow>
          </TableHead>
          <TableBody>{children}</TableBody>
        </Table>
      </TableContainer>
    );
  }

  return DynamicTable;
}
